// extracted by mini-css-extract-plugin
module.exports = {"html":"e_2w"};